@for (student of school.students; track trackByFn($index, student)) {
  <app-new-student-item
    [student]="student"
    [showAttendance]="school.hasAttendance"
  (selectStudent)="selectStudent.emit({ schoolId: school.id, studentId: $event })"></app-new-student-item>
}
